export const ChatDisplayState = {
  NONE: 'NONE',
  MINIMIZED: 'MINIMIZED',
  REQUEST_FORM: 'REQUEST_FORM',
  CHAT_OPENED: 'CHAT_OPENED',
  CHAT_IN_QUEUE: 'CHAT_IN_QUEUE',
  FINISHED: 'FINISHED',
  CHAT_ENTRANCE_CLOSED: 'CHAT_ENTRANCE_CLOSED',
  BEFORE_CLOSE: 'CHAT_BEFORE_CLOSE',
}

export const ChatState = {
  NONE: 'NONE',
  CONNECTING: 'CONNECTING',
  ONGOING: 'ONGOING',
  CLOSED: 'CLOSED',
}

export const ChatLine = {
  CREDIT_SUPPORT: 'CreditSupport',
  PAYMENTS_SUPPORT: 'ChatSupport',
  STORE_SUPPORT: 'ChatSupport',
  STORE_MATERIAL_SUPPORT: 'ChatSupport',
  TERMINAL_SUPPORT: 'ChatSupport',
}
